import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaBuilding,
} from "react-icons/fa";
import { useDispatch } from "react-redux";
import { SellerRegisterApi } from "../../redux/slices/SellerRegisterSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SellerRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
    businessName: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    toast.success("User Not Found!", {
      position: "top-right",
      autoClose: 2000,
      style: {
        backgroundColor: "#d0d3d4 ",
        color: "black",
        fontWeight: "bold",
        borderRadius: "8px",
      },
    });
    navigate("/SellerLogin");
    // e.preventDefault();
    // dispatch(SellerRegisterApi(formData)).then((result) => {
    //   if (result.meta.requestStatus === "fulfilled") {
    //     navigate("/SellerLogin");

    //   } else {
    //     toast.error("User Not Found!", {
    //       position: "top-right",
    //       autoClose: 2000,
    //       style: {
    //         backgroundColor: "#d0d3d4 ",
    //         color: "black",
    //         fontWeight: "bold",
    //         borderRadius: "8px",
    //       },
    //     });
    //   }
    // });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center  bg-gradient-to-br sm:from-pink-50 via-blue-200 to-white py-10">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-[95%] sm:w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-500 mb-6">
          Register as a Seller
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center border-2 border-gray-300 rounded-lg p-3 focus-within:border-purple-500 transition-all">
            <FaUser className="text-purple-500 mr-3" />
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full outline-none bg-transparent"
              required
            />
          </div>

          <div className="flex items-center border-2 border-gray-300 rounded-lg p-3 focus-within:border-blue-500 transition-all">
            <FaEnvelope className="text-blue-500 mr-3" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full outline-none bg-transparent"
              required
            />
          </div>

          <div className="flex items-center border-2 border-gray-300 rounded-lg p-3 focus-within:border-pink-500 transition-all">
            <FaLock className="text-pink-500 mr-3" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="w-full outline-none bg-transparent"
              required
            />
          </div>

          <div className="flex items-center border-2 border-gray-300 rounded-lg p-3 focus-within:border-green-500 transition-all">
            <FaPhone className="text-green-500 mr-3" />
            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full outline-none bg-transparent"
              required
            />
          </div>

          <div className="flex items-center border-2 border-gray-300 rounded-lg p-3 focus-within:border-orange-500 transition-all">
            <FaBuilding className="text-orange-500 mr-3" />
            <input
              type="text"
              name="businessName"
              placeholder="Business Name"
              value={formData.businessName}
              onChange={handleChange}
              className="w-full outline-none bg-transparent"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded font-bold hover:bg-blue-700"
          >
            Register
          </button>
        </form>

        <p className="text-center mt-5 text-gray-600">
          Already have an account?{" "}
          <a
            href="/SellerLogin"
            className="text-purple-600 font-semibold hover:underline"
          >
            Login
          </a>
        </p>
      </div>
    </div>
  );
};

export default SellerRegister;
